import { inject, Injectable, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ErrorDialogComponent } from './dialog/error-dialog.component';
import { ErrorDialogData } from './error.types';

@Injectable({
  providedIn: 'root',
})
export class ErrorService implements OnDestroy {
  private readonly _dialog = inject(MatDialog);
  private _subscription = new Subscription();

  openDialog(error: ErrorDialogData): void {
    const dialogRef = this._dialog.open<
      ErrorDialogComponent,
      ErrorDialogData,
      unknown
    >(ErrorDialogComponent, {
      autoFocus: false,
      disableClose: false,
      data: error,
      panelClass: 'error-dialog-panel',
    });

    this._subscription = dialogRef
      .afterClosed()
      .subscribe(() => this._subscription.unsubscribe());
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }
}
